import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const Adsense = () => {
  // Çevre değişkeninden AdSense'in aktif olup olmadığını kontrol et
  const isAdsenseEnabled = process.env.REACT_APP_ADSENSE_ENABLED === 'true';

  useEffect(() => {
    // AdSense sadece aktif ise çalıştır
    if (isAdsenseEnabled) {
      // AdSense kodunu yükle
      const script = document.createElement("script");
      script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8547891989124733";
      script.async = true;
      script.crossOrigin = "anonymous";
      document.body.appendChild(script);

      // AdSense reklamını başlat
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (error) {
        console.error("AdSense hatası:", error);
      }

      // Component unmount olduğunda script'i temizle
      return () => {
        if (document.body.contains(script)) {
          document.body.removeChild(script);
        }
      };
    }
  }, [isAdsenseEnabled]);

  // AdSense aktif değilse null döndür (hiçbir şey gösterme)
  if (!isAdsenseEnabled) {
    return null;
  }

  return (
    <>
      
      <div className="row item-list item-list-sm m-b">
        <div className="col-xs-12">
          {/* <Link to="#"> <img src="/images/reklam.jpg" alt="reklam"/></Link> */}
          
          {/* muzisyen_sidebar */}
          <ins 
            className="adsbygoogle"
            style={{ display: "block" }}
            data-ad-client="ca-pub-8547891989124733"
            data-ad-slot="7497849088"
            data-ad-format="auto"
            data-full-width-responsive="true"
          />
        </div>
      </div>
    </>
  );
};

export default Adsense;
